import { useMemo } from "react";
import { fetchRCSPartnersByCustomer } from "../api/RCSPartnerErrorsLogs";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../../../Context/AuthContext";

export const useFetchPartnersByCustomers = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  const { data, isPending } = useQuery({
    queryKey: ["fetchPartnersByCustomers"],
    queryFn: async () =>
      await fetchRCSPartnersByCustomer({
        token: user.token,
      }),
    refetchOnWindowFocus: false,
    initialData: [],
  });

  const memoizedData = useMemo(() => {

    const getUidCustomer = () => {
      return data.find((item) => item.uidpartner === user?.uid_partner)
        ?.idcustomer;
    };

    const getPartners = () => {
      return data.filter((item) => item.idcustomer === getUidCustomer());
    };

    return {
      partners: getPartners(),
    };
  }, [data]);

  return {
    data: memoizedData.partners,
    isPending,
  };
};
